import AuthenticatedHome from '@/modules/home/pages/authenticated.home.vue';

export const authenticatedHomeRoutes = [
    {
        path: `${process.env.BASE_URL}home`,
        component: () => import('@/layout/default.layout.vue'),
        children: [{
            path: '',
            component: AuthenticatedHome,
            meta: {
                requiresAuth: true,
            },
        }],
    },
];
